import { useEffect as e, useRef as t, useState as n } from "react";
import { styled as r } from "styled-components";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/Drawer/ContextualDrawer.tsx
var o = r.div`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 101; /* Above MobileBottomNav which is 100 */
    background-color: ${({ theme: e }) => e.colors.card};
    box-shadow: ${({ theme: e }) => e.shadows.xl};
    border-top: 1px solid ${({ theme: e }) => e.colors.border};
    border-top-left-radius: ${({ theme: e, $isExpanded: t }) => t ? "0" : e.radii.xl};
    border-top-right-radius: ${({ theme: e, $isExpanded: t }) => t ? "0" : e.radii.xl};
    display: flex;
    flex-direction: column;
    overflow: hidden;

    /* Full height; visibility is managed via translateY. */
    height: 100vh;
    height: 100dvh;

    will-change: transform, border-radius;
    transition: ${({ $isDragging: e }) => e ? "none" : "transform 300ms cubic-bezier(0.4, 0, 0.2, 1), border-radius 300ms"};
`, s = r.div`
    width: 100%;
    padding: ${({ theme: e }) => e.spacing(2)};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: grab;
    flex-shrink: 0;

    &:active {
        cursor: grabbing;
    }
`, c = r.div`
    width: 40px;
    height: 4px;
    border-radius: ${({ theme: e }) => e.radii.full};
    background-color: ${({ theme: e }) => e.colors.border};
`, l = r.div`
    flex: 1;
    overflow-y: ${({ $state: e }) => e === "expanded" ? "auto" : "hidden"};
    width: 100%;
    padding-bottom: env(safe-area-inset-bottom, 0px);
`, u = ({ state: r, setState: u, content: d, scrollRef: f, preventClose: p = !0 }) => {
	let m = t(null), [h, g] = n(!1), _ = t({
		startY: 0,
		currentY: 0,
		initialTranslateY: 0,
		lastTimestamp: 0,
		velocity: 0
	}), v = () => typeof window < "u" ? window.innerHeight : 800, y = (e) => {
		let t = v();
		switch (e) {
			case "hidden": return t;
			case "expanded": return 0;
			case "minimized": return t - Math.min(t * .5, 360);
		}
	};
	e(() => {
		!h && m.current && (m.current.style.transform = `translateY(${y(r)}px)`);
	}, [r, h]);
	let b = (e) => {
		g(!0), _.current = {
			startY: e,
			currentY: e,
			initialTranslateY: y(r),
			lastTimestamp: performance.now(),
			velocity: 0
		};
	}, x = (e) => b(e.touches[0].clientY), S = (e) => b(e.clientY);
	e(() => {
		if (!h) return;
		let e = (e) => {
			let t = "touches" in e ? e.touches[0].clientY : e.clientY, n = t - _.current.startY, r = _.current.initialTranslateY + n, i = v(), a = i - Math.min(i * .5, 360);
			r < 0 ? r *= .3 : p && r > a && (r = a + (r - a) * .2), m.current && (m.current.style.transform = `translateY(${r}px)`);
			let o = performance.now(), s = o - _.current.lastTimestamp;
			s > 0 && (_.current.velocity = (t - _.current.currentY) / s), _.current.currentY = t, _.current.lastTimestamp = o;
		}, t = () => {
			g(!1);
			let e = _.current.initialTranslateY + (_.current.currentY - _.current.startY), { velocity: t } = _.current, n = v(), i = n - Math.min(n * .5, 360), a = r;
			a = t < -.5 ? "expanded" : t > .5 ? "minimized" : Math.abs(e - 0) < Math.abs(e - i) ? "expanded" : "minimized", a === r ? m.current && (m.current.style.transform = `translateY(${y(r)}px)`) : u(a);
		}, n = (t) => {
			t.cancelable && t.preventDefault(), e(t);
		};
		return window.addEventListener("touchmove", n, { passive: !1 }), window.addEventListener("touchend", t), window.addEventListener("mousemove", e), window.addEventListener("mouseup", t), () => {
			window.removeEventListener("touchmove", n), window.removeEventListener("touchend", t), window.removeEventListener("mousemove", e), window.removeEventListener("mouseup", t);
		};
	}, [
		h,
		r,
		u
	]);
	let C = y(r);
	return d ? /* @__PURE__ */ a(o, {
		ref: m,
		$isDragging: h,
		$isExpanded: r === "expanded",
		"aria-hidden": r === "hidden",
		style: {
			transform: `translateY(${C}px)`,
			pointerEvents: r === "hidden" ? "none" : "auto"
		},
		children: [/* @__PURE__ */ i(s, {
			onTouchStart: x,
			onMouseDown: S,
			children: /* @__PURE__ */ i(c, {})
		}), /* @__PURE__ */ i(l, {
			ref: f,
			$state: r,
			onTouchStart: r === "minimized" ? x : void 0,
			onMouseDown: r === "minimized" ? S : void 0,
			children: d
		})]
	}) : null;
};
//#endregion
export { u as ContextualDrawer };
